import { takeEvery, put } from 'redux-saga/effects';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

export const consts = createReqConsts('communities', 'postDetails', [
  'CLEAR',
  'EDIT',
  'LIKE',
  'DISLIKE',
  'ADD_COMMENT',
  'ADD_COMMENTS',
  'DELETE_COMMENT',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'communities',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['communityId'],
    },
    'posts',
    {
      type: 'payload',
      selector: ['postId'],
    },
  ],
});

const reqReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.CLEAR:
      return initialState;
    case consts.EDIT:
      return Object.assign({}, state, payload);
    case consts.LIKE:
      return Object.assign({}, state, {
        liked: true,
        totalLikes: state.totalLikes + 1,
      });
    case consts.DISLIKE:
      return Object.assign({}, state, {
        liked: false,
        totalLikes: state.totalLikes - 1,
      });
    case consts.ADD_COMMENT:
      return Object.assign({}, state, {
        totalComments: state.totalComments + 1,
      });
    case consts.ADD_COMMENTS:
      return Object.assign({}, state, {
        totalComments: state.totalComments + action.payload,
      });
    case consts.DELETE_COMMENT:
      return Object.assign({}, state, {
        totalComments: state.totalComments - 1,
      });
    default:
      return reqReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/communities/postDetails.js